
const contactForm = () => ({
    ...window.helpers,
    name: '',
    email: '',
    subject: '',
    message: '',
    copy: false,
    copyChecked: false,
    submitting: false,
    fieldKeys: ['name', 'email', 'subject', 'message'],
    submitForm() {
        this.initAndExecuteGoogleCaptcha(window.location.pathname).then((token) => {
            // disable button and clear errors
            this.submitting = true
            this.errors = {}

            const params = new URLSearchParams()
            params.append('captcha_token', token)
            params.append('captcha_action', window.location.pathname)
            params.append('name', this.name)
            params.append('email', this.email)
            params.append('subject', this.subject)
            params.append('message', this.message)
            params.append('copy', this.copy)
            params.append('ajax', 'true')
            params.append('contactFormSubmission', 'true')
            params.append('contactType', window.Alpine.store('general').contactType)

            if (window.Alpine.store('gclid').gclid !== null && window.Alpine.store('gclid').utl !== null && new Date().getTime() < window.Alpine.store('gclid').utl) {
                params.append('offline_tracking_gclid', window.Alpine.store('gclid').gclid)
            }

            window.api.post('/contact', params).then((response) => {
                this.submitting = false
                if (response.data.success === true) {
                    this.successfulSubmission = true
                    window.dispatchEvent(new CustomEvent('gtmdata', {
                        detail: {
                            event: 'gtm_contact',
                        },
                    }))
                    this.name = ''
                    this.email = ''
                    this.subject = ''
                    this.message = ''
                    this.copy = false
                    this.copyChecked = false
                } else {
                    this.processServersideErrors(response.data)
                }
            }).catch((error) => {
                this.submitting = false
                this.processServersideErrors(error.response.data)
            })
        })
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('contactForm', contactForm)
})
